import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ApiResult } from "@app/shared/model/apiresult";
import { Guid } from "guid-typescript";
import { catchError, map } from 'rxjs/operators';
import { environment as env } from '@environments/environment'
import { throwError } from "rxjs";
import { IPersonAddress } from "../model/personaddress";

@Injectable({ providedIn: 'root' })

export class PersonAddressService {
    constructor(private http: HttpClient) { }

    get(personId: Guid) {
        return this.http.get<ApiResult<IPersonAddress[]>>(env.apiUrl + 'PersonAddress/' + personId);
    }
    post(studentDocument: IPersonAddress) {
        return this.http.post<ApiResult<number>>(env.apiUrl + 'PersonAddress', studentDocument).pipe(catchError(this.handleError))
    }
    put(studentDocument: IPersonAddress) {
        return this.http.put<ApiResult<number>>(env.apiUrl + 'PersonAddress', studentDocument);
    }
    delete(id: Guid) {
        return this.http.delete<ApiResult<any>>(env.apiUrl + 'PersonAddress/' + id);
    }
    handleError(error: HttpErrorResponse) {
        return throwError(error);
    }
}